import React from "react"
let headerStyles = {
    // 'width': '100%',
    'height': '100%',
    'overflow-x': 'hidden'
}

export default () => (
    <img style={headerStyles} src={'/img/background-1.png'}/>
)